import React from 'react'
import Gallery from '../Components/Gallery';
import Banner from '../Components/Banner';
import ContactSection from '../Components/ContactSection';
import BannerImage from "../Images/gallery-banner.jpg";

const GallerySec = () => {
    const bannerTitle = (
        <>
          Gallery
        </>
      );
      const bannerContent = "";
      const bannerConclude = "";
  return (
    <>
    <Banner image={BannerImage} propAlt={"Home Banner"} 
          bannerTitle={bannerTitle} bannerContent={bannerContent} bannerConclude={bannerConclude} />  
    <Gallery />
    <ContactSection />
    </>
  )
}

export default GallerySec